import {getScheduleHours} from "../schedule";

class bookingCreateController{
  constructor(
    $injector,
    $bookings,
    $rootScope,
    $auth,
    CONFIG,
    $scope,
    $uibModal,
    $timeout
  ){

    'ngInject';

    this.$bookings      = $bookings;
    this.$auth          = $auth;
    this.$rootScope     = $rootScope;

    this.CONFIG         = CONFIG;

    this.$scope     = $scope;
    this.$timeout   = $timeout;
    this.$uibModal  = $uibModal;
    this.notify   = $injector.get('ngNotify');
    this.ready = false;
    this.adrFile = null;

    this._selectedOperatorId = null;
    this.operatorId = null;

    this.uploaddVehicles = {};

    this.ETVehicleWidth = [
      { value: 7.49, label: 'Poniżej 7,5m' },
      { value: 13, label: 'Pomiędzy 7,5 a 13m' },
      { value: 19, label: 'Powyżej 13m' },
    ];

    this.tunnelVehicleWidth = [
      { value: 10, label: 'Do 10 m' },
      { value: 18.75, label: 'Do 18,75 m'},
    ];

    this.ref2options = [
      { value: 'izoterma', label: 'Izoterma' },
      { value: 'plandeka', label: 'Plandeka' },
    ]

    this.$rootScope.$on('reloadUploadedVehicles', () => this.loadUploadedVehicles());
    setTimeout(() => $bookings.initReady$.then( () => this.dataReady()));
  }

  get operator() {
    if (this.operators && this.operators.length > 0) {
      const _operator = this.operators.find(o => o.id === this._selectedOperatorId)
      return _operator ? _operator.operator_code : null;
    } else {
      return null;
    }
  }

  get operatorAltName() {
    if (this.operators && this.operators.length > 0) {
      const _operator = this.operators.find(o => o.id === this._selectedOperatorId)
      return _operator && _operator.operator_code_alt ? _operator.operator_code_alt : this.operator;
    } else {
      return null;
    }
  }

  getOperatorLogo(operator) {
    return operator.logo || `${operator.operator_code.toLowerCase()}.svg`
  }

  onRouteChange() {
    this.reservation.route = Object.assign({}, this.reservation.route);
    this.reservation.route.operator = this.operator;
    this.setDefaultVehicleBody();
    this.setDefaultDepartureHour();
  }

  setDefaultVehicleBody(noWidth = false){
    let getVehicleBodyByName = ( name ) => {
      return this.vehicleBodies[this.reservation.route.operator][0];
          // .filter( body => body.name === name )[0];
    };
    this.reservation.vehicle_type   = getVehicleBodyByName('unit');
    this.reservation.vehicle_length = noWidth ? this.ETVehicleWidth[1] : (this.reservation.vehicle_type && this.reservation.vehicle_type.length ? this.reservation.vehicle_type.length : 16.5);
    if (['MONTBLANC', 'MONTBLANC_CZ', 'FREJUS', 'FREJUS_CZ'].includes(this.operator)) {
      this.reservation.vehicle_length = this.tunnelVehicleWidth[0];
    }
    this.reservation.weight         = 24;
  }

  setDefaultDepartureHour(){
    this.reservation.departure_hours = '';
    $('#departure_hours').parent().parent().removeClass('has-error');
  }

  selectOperator(operatorId = null) {
    operatorId && (this._selectedOperatorId = operatorId);
    console.log(this.operator);
    const _operator = this.operatorAltName;
    this.routes = this.getRoutes(_operator);
    this.reservation.route = Object.assign({}, this.routes[0]);
    this.reservation.route.operator = this.operator;
    this.setDefaultVehicleBody(['EUROTUN', 'EUROTUN_CZ', 'MONTBLANC', 'MONTBLANC_CZ', 'FREJUS', 'FREJUS_CZ'].includes(this.operator));
  }

  $onInit(){
    this.multiple = 1;
    this.empty = false;
    this.returnRoute = false;
    this.adrFile = null;
    this.showAgreements();
  }


  dataReady() {
    this.routes = [];
    this.operators = this.$bookings.collections.operators;
    if (this.operators.length > 0) {
      //this.operator = this.operators[0].operator_code;
      this._selectedOperatorId = this.operators[0].id;
    }
    this.vehicleBodies = this.$bookings.collections.vehicleBodies;
    this.ready = true;

    setTimeout(() => {
      this.reservation = {
        route               : null,
        departure_date      : angular.copy(window.moment().startOf('day')),
        departure_hours     : '',
        vehicle_number      : null,
        vehicle_trailer_id  : null,
        number_of_drivers   : 1,
        description         : null,
        contractor          : null,
        booking_ref         : '',
        driver_phone_no     : '',
        plug_in             : false,
        mrn                 : null,
        customer            : '',
        vat_id              : '',
        ref1                : '',
        ref2                : '',
        tallink_route_id    : '',
      };
      this.selectOperator();
      this.setDefaultVehicleBody();
      this.loadUploadedVehicles();
    });



  }

  isAfterhoursForPolsca() {
    const hour = parseInt(new Intl.DateTimeFormat('pl', {
      timeZone: 'Europe/Warsaw',
      hour: 'numeric',
      hour12: false
    }).format(new Date()), 10);
    return hour >= 22 || hour < 8;
  }

  $onSubmit( formBookingCreate ){
    if (this.operator === 'POLSCA_EMAIL' && this.isAfterhoursForPolsca()) {
      formBookingCreate.$submitted = false;
      this.showAfterhoursNote();
      return;
    }

    let h   = this.reservation.departure_hours,
        hm  = (h === '' ? '00:00' : h).split(':');

    this.reservation = this.$bookings.updateTallinkData(this.reservation);

    this.reservation.route          = String(this.reservation.route.uri);
    this.reservation.vehicle_type   = String(this.reservation.vehicle_type.name);

    if (typeof this.reservation.vehicle_length === 'object') {
      this.reservation.vehicle_length = this.reservation.vehicle_length.value;
    }

    if (this.empty || !this.reservation.weight) {
      this.reservation.weight = 0;
    }

    let route = this.routes.find(r => r.uri === this.reservation.route);
    this.reservation = this.$bookings.adjustDepartureDate(this.reservation, route);
    this.reservation.vehicle_length = this.overrideVehicleLength(this.reservation, route.operator);

    if (this.reservation.ref2) {
      this.reservation.ref2 = this.reservation.ref2.value;
    }

    this.$bookings.multiCreate(this.reservation, this.adrFile, this.returnRoute)
      .then(() => this.$onInit())
      .then(() => this.dataReady())
      .then(() => this.app.openedComponent = false )
      .then(() => this.$timeout(() => this.$scope.$apply(), 0))
      .catch(response => {
				console.log(response);
				this.notify.set(response.data.reason || 'Coś poszło nie tak', 'error')
			})
      .finally(() => formBookingCreate.$submitted = false );


  }

  overrideVehicleLength(booking, operator) {
    if (booking.vehicle_number) {
      const vehicle_number = booking.vehicle_number.replace(/ /g, '').toUpperCase();
      if (this.uploaddVehicles && this.uploaddVehicles[operator] && this.uploaddVehicles[operator].length
      ) {
        const data = this.uploaddVehicles[operator].find(v => v.vehicle === vehicle_number);
        if (data) {
          return data.length
        } else
          return booking.vehicle_length;
      } else {
        return booking.vehicle_length;
      }
    } else if (booking.vehicle_length) {
      return booking.vehicle_length;
    }
  }

  get showHours() {
    return this.reservation && this.reservation.route && this.reservation.route.schedule && !this.reservation.route.silent_schedule;
  }

  getRoutes(operator) {
    console.log(operator);
    return this.$bookings.collections.routes.filter(r => r.operator_alt && r.operator_alt === operator || !r.operator_alt && r.operator === operator);
  }

  $onSetTime(){
    $('#dropdown2').parent().removeClass('open');
    this.reservation.departure_hours = '';
  }

  $onMultiBooking() {
    const booking = this.reservation;
    const count = this.multiple;
    const returnRoute = this.returnRoute;
		this.$uibModal.open({
			component: 'booking-multi',
      windowTopClass: 'booking-multi-modal',
			resolve: {
				items: function () {
					return {
						booking: booking,
            count: count,
            returnRoute: returnRoute
					}
				}
			}
		});
	}

	showAgreements() {
    const agreements = this.userAgreements;
    let accepted = true;
    Object.keys(agreements).forEach(key => accepted = accepted && agreements[key]);
    if (!accepted) {
      this.$uibModal.open({
        component: 'agreements',
        resolve: {
          items: function () {
            return {
              agreements: agreements
            }
          }
        }
      });
    }
  }

  showAfterhoursNote() {
    this.$uibModal.open({
      component: 'afterhours',
      windowClass: 'center-modal',
    });
  }

  get availableVehicleBodies() {
    let bodies = null;
    if (this.vehicleBodies && this.reservation && this.reservation.route) {
      const routeOperator = this.reservation.route.operator;
      if (routeOperator) {
        bodies = this.vehicleBodies && this.vehicleBodies[routeOperator].map(b => Object.assign({}, b, {title: this.$bookings.$translates.get(b.name)}));
      }
    }
    return bodies;
  }

  get userAgreements() {
    let agreements = {
			tandc: false,
			privacy: false,
		}
		return this.$auth.getUser().agreements ? JSON.parse(this.$auth.getUser().agreements) : agreements;
  }

  beforeRender ($view, $dates) {
    const minDate = window.moment().startOf($view).valueOf(),
          maxDate = window.moment().add(14, 'days').startOf($view).valueOf();
    angular.forEach($dates, function(date) {
        const localDateValue = date.localDateValue();
        date.selectable = localDateValue >= minDate && localDateValue <= maxDate;
    });
  };

  get selectedVehicleBody() {
    if (this.reservation && this.reservation.route && this.reservation.route.operator && this.reservation.vehicle_type) {
      return this.vehicleBodies[this.reservation.route.operator].find(vb => vb.id === this.reservation.vehicle_type.id);
    } else {
      return null;
    }
  }

  get vbLengthRange() {
    const vb = this.selectedVehicleBody;
    return {
      min: vb && vb.minLength || 0,
      max: vb && vb.maxLength || 22
    }
  }

  onVehicleBodyChange() {
    const vb = this.selectedVehicleBody;
    this.reservation.vehicle_length = vb.length || vb.minLength;
    this.reservation.weight = vb.weight;
  }

  get isSpeditor() {
    return this.$bookings.mode === 'SPEDITOR';
  }

  searchCompanyByNip() {
    const nip = this.reservation.vat_id;
    this.ready = false;
    this.$bookings.getCompanyByNip(nip)
      .then(response => {
        if (response.company_name !== undefined) {
          this.$bookings.getLimitTest(nip)
          .then(res => {
            this.ready = true;
            if (res && res.amount <= 0) {
              this.notify.set('Przekroczone dopuszczalne parametry. Brak możliwości złożenia bookingu.', 'error')
            } else {
              this.reservation.customer = response.company_name;
            }
          }).catch(res => {
            this.notify.set('Brak dostępu do serwera limitów - sprawdź połączenie VPN.', 'error')
            this.ready = true;
          });
        } else {
          this.ready = true;
          this.notify.set('Nie znaleziono firmy', 'error')
        }
      })
      .catch(response => {
				console.log(response);
				this.notify.set(response.data.reason || 'Coś poszło nie tak', 'error')
			})
  }

  clearCompany() {
    if (this.reservation.customer !== '') {
      this.reservation.customer = '';
    }
  }

  cleanString(val, removeLetters = false) {
    if (!val) {
      return val;
    }
    let output = val.trim().replace(/\s/g, "").replace(/-/g, "")
    return removeLetters ? output.replace(/\D/g,'') : output;
  }

  // this should be modified based on circumstances
  get isValidCustomValidation() {
    return true;

    // if (this.reservation.route.operator === 'MONTBLANC_XLS') {
    //   const dep = this.reservation.departure_date;
    //   const minDate = new Date('2024-09-01T22:00:00');
    //   const maxDate = new Date('2024-12-16');
    //   if (dep >= minDate && dep <= maxDate) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // } else {
    //   return true;
    // }
  }

  get checkCustomer() {
    return this.reservation && this.reservation.customer !== '' && this.reservation.vat_id !== '';
  }

  loadUploadedVehicles() {
    this.$bookings.getUploadedVehicles()
      .then(data => this.uploaddVehicles = data);
  }

  onAdrFileSelect($event) {
    const file = $event.target.files[0];
    if (file) {
      this.adrFile = file;
      this.$scope.$apply();
    }
  }

  onAdrFileClear() {
    this.adrFile = null;
  }

}

export default bookingCreateController;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-create/booking-create.controller.js
 **/